import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const TextArea = ({
  label,
  name,
  value,
  onChange,
  placeholder = '',
  required = false,
  disabled = false,
  error = '',
  className = '',
  minHeight = 80,
  ...props
}) => {
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  const handleChange = (e) => {
    adjustHeight();
    onChange(e);
  };

  return (
    <div className="textarea-wrapper">
      {label && (
        <label htmlFor={name} className="textarea-label">
          {label} {required && <span className="required">*</span>}
        </label>
      )}

      <textarea
        ref={textareaRef}
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`text_area ${error ? 'textarea-error' : ''} ${className}`}
        style={{ minHeight }}
        {...props}
      />

      {error && <div className="textarea-error-message">{error}</div>}
    </div>
  );
};
TextArea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  minHeight: PropTypes.number,
};

export default TextArea;
